// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GFQQ","field":"styles_field__3q2nL","fieldCol":"styles_fieldCol__2EzTs","diffCol":"styles_diffCol__16oOH","diff":"styles_diff__2usf5"};